export const COMMISSION_LIST = ([
    {
        "level": "1",
        "title": "≥10,00",
        "value": "5%"
    },
    {
        "level": "2",
        "title": "≥500,00",
        "value": "6%"
    },
    {
        "level": "3",
        "title": "≥1.000,00",
        "value": "8%"
    },
    {
        "level": "4",
        "title": "≥5.000,00",
        "value": "10%"
    },
    {
        "level": "5",
        "title": "≥10.000,00",
        "value": "15%"
    },
    {
        "level": "6",
        "title": "≥30.000,00",
        "value": "20%"
    },
    {
        "level": "7",
        "title": "≥50.000,00",
        "value": "25%"
    }
])

export interface FundViewData{
    availableBalance: number
}